/**
 * @generated SignedSource<<c66de7bab7c46c19eed43f36958f8dc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Contact_Contact$data = {
  readonly directChatThread?: {
    readonly id: string;
  } | null | undefined;
  readonly id?: string;
  readonly name?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"RecipientAvatar_Recipient" | "chat_useContactDescription">;
  readonly " $fragmentType": "Contact_Contact";
};
export type Contact_Contact$key = {
  readonly " $data"?: Contact_Contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"Contact_Contact">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ChatThread",
    "kind": "LinkedField",
    "name": "directChatThread",
    "plural": false,
    "selections": [
      (v0/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Contact_Contact",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "ChatBot",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecipientAvatar_Recipient"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "chat_useContactDescription"
    }
  ],
  "type": "Recipient",
  "abstractKey": "__isRecipient"
};
})();

(node as any).hash = "6af9594572bf7b5ed65f790b626ceb1d";

export default node;
